import React from 'react'
import Link from 'gatsby-link'
import { Panel, Image, Col } from 'react-bootstrap';
import imperialLogo from '../../images/imperial.jpg'
import cloud from "../../images/wordcloud.svg"


const IndexPage = () => (
				<Panel header="Looking for PhD Candidates"><Panel.Heading>Looking for PhD Candidates</Panel.Heading>
				<Panel.Body>
				<Col xs={8} md={4} mdPush={8}>
				<Image src={imperialLogo}/>
				</Col>
				<Col md={8} mdPull={4}>
<h2>About the Position</h2>
<p>High-Performance Data Management enables a landscape of new and
exciting applications such as interactive data exploration, realtime
stream processing or predictive analytics. Applications are found in a
variety of fields such as computer games, finance, sensor data
		processing, data science and many more.</p>
				
<p>To help shape current and future trends in High-Performance Data
		Management, I invite you to submit your application for a position
		as a <b>PhD student under my supervision</b>. Candidates will need a strong background in computer science (though, not necessarily a degree in that field), ideally
with some experience in one or more of the following areas:</p>
				<ul>
				<li>data management,</li><li>compilers,</li><li>computer architecture,</li>
				<li>hardware acceleration (GPUs, FPGAs, Xeon Phi, ...) or</li>
				<li>high-performance computing.</li>
				</ul>

<p>We will provide an exciting research environment in a diverse,
internationally well-connected group. This includes collaborative
visits to research groups abroad as well as support for industry and
academic internships.</p>
<p>Feel free to informally contact <Link to="mailto:hlgr@ic.ac.uk">me by email</Link> if you have questions.</p>

<h2>About the Department</h2>
The Department of Computing is a leading department of Computer
Science among UK universities as well as worldwide, and has consistently been awarded the
highest research rating. In the 2014 REF assessment, The Department
was ranked third (1st in the Research Intensity table published by The
Times Higher), and was rated as "Excellent" in the previous national
assessment of teaching quality.


<h2>Formalities</h2>
<p>Applications can be submitted <b>throughout the year</b> using the college
application system (see <Link to="http://www.imperial.ac.uk/computing/prospective-students/phd/phd-application-guidelines">
the application guidelines</Link>). Please, state High-Performance Data Management in the
title and select "Dr. Holger Pirk" as the "Proposed Research Supervisor".</p>




		
				</Col>
				<Col md={12}>
				Please submit your application through the <a href="http://www.imperial.ac.uk/computing/prospective-students/phd"> college
		application system</a>.
				</Col>
				<Col xs={12} md={8} mdPush={2} style={{marginTop:20}}>
				<Image src={cloud} responsive rounded/>
				</Col>
				</Panel.Body>
		</Panel>
		

)

export default IndexPage




// WEBPACK FOOTER //
// ./src/pages/research/openings.js